'use strict';

const FlowCard = require('./FlowCard');

/**
 * @class
 * @hideconstructor
 * @extends HomeyAPIV3.Item
 * @memberof HomeyAPIV3.ManagerFlow
 */
class FlowCardTrigger extends FlowCard {

  get uri() {
    console.warn('FlowCardTrigger.uri is deprecated. Use FlowCardTrigger.ownerUri instead.');
    return undefined;
  }

  get uriObj() {
    console.warn('FlowCardTrigger.uriObj is deprecated.');
    return undefined;
  }

}

module.exports = FlowCardTrigger;
